import React from "react";
import {
  Box,
  Button,
  InputAdornment,
  Pagination,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import SearchIcon from "@mui/icons-material/Search";

export default function TableInversionistas({
  results,
  search,
  setSearch,
  page,
  rowsPerPage,
  totalPages,
  handleChangePage,
  irA
}) {

  const noData = () => (
    <Box
      sx={{
        width: "100%",
        height: 70,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <ManageSearchIcon sx={{ color: "#737791" }} />
      <Typography
        variant="body1"
        color="#737791"
      >
        Sin datos por mostrar
      </Typography>
    </Box>
  );

  return (
    <>
      <Paper sx={{ width: "100%", padding: 3 }}>
        <Box sx={{ padding: 1 }}>
          <TextField
            id="search"
            label="Buscar por nombre, RFC, correo, etc..."
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              },
            }}
            variant="standard"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            fullWidth
          />
        </Box>
        {results && results.length
          ? <TableContainer
            className="table-content"
            components={{
              Container: props => <Paper {...props} elevation={0} />
            }}
          >
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell>Inversionista</TableCell>
                  <TableCell>Correo</TableCell>
                  <TableCell>RFC</TableCell>
                  <TableCell>Total invertido</TableCell>
                  <TableCell>Total servicios</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {(rowsPerPage > 0
                  ? results.slice((page - 1) * rowsPerPage, page * rowsPerPage)
                  : results
                ).map((row, i) => {
                  return (
                    <TableRow
                      key={i}
                      sx={{ "& td, & th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">{row.name}</TableCell>
                      <TableCell>{row.email}</TableCell>
                      <TableCell>{row.rfc}</TableCell>
                      <TableCell>${row.total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      <TableCell>${row.services.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</TableCell>
                      <TableCell>
                        <Button
                          onClick={() => irA(row.link)}
                          size="small"
                          sx={{ fontSize: "14px", textTransform: "none" }}
                        >
                          Ver detalles
                        </Button>
                      </TableCell>
                    </TableRow>
                  )
                }
                )}
              </TableBody>
            </Table>
          </TableContainer>
          : noData()
        }
      </Paper>
      {results.length
        ? <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "center"
          }}
        >
          <Stack className="pagination" spacing={2} mt={3}>
            <Pagination
              sx={{ width: "100%" }}
              color="primary"
              shape="rounded"
              count={totalPages}
              onChange={(event, value) => handleChangePage(value)}
              page={page}
              size="large"
            />
          </Stack>
        </Box>
        : <></>
      }
    </>
  );
}
